<template>

  <div>
     ======= Top Bar =======
    <div id="topbar" class="d-none d-lg-flex align-items-center fixed-top">
      <div class="container d-flex">
        <div class="contact-info mr-auto">
          <i class="icofont-envelope"></i> <a href="mailto:contact@example.com">contact@example.com</a>
          <i class="icofont-phone"></i> +1 5589 55488 55
          <i class="icofont-google-map"></i> A108 Adam Street, NY
        </div>
        <div class="social-links">
          <a href="#" class="twitter"><i class="icofont-twitter"></i></a>
          <a href="#" class="facebook"><i class="icofont-facebook"></i></a>
          <a href="#" class="instagram"><i class="icofont-instagram"></i></a>
          <a href="#" class="skype"><i class="icofont-skype"></i></a>
          <a href="#" class="linkedin"><i class="icofont-linkedin"></i></a>
        </div>
      </div>
    </div>

<!-- ======= Header Start ======= -->
    <header id="header" class="fixed-top">
      <div class="container d-flex align-items-center">
        <div class="align-items mr-4">
          <b-row>
            <img src="./../../assets/images/app_icon.png"
                 style="border-radius: 50%; margin-right: 15px; margin-left: 15px;" height="40" width="40"
                 alt="app logo"/>
            <div class="mt-1 d-none d-lg-block d-md-block">
              <h2 class="logo mr-auto"><router-link :to="{name: 'generalUserHome'}"> Ekhoni Daktar</router-link></h2>
            </div>
          </b-row>
        </div>
        <!-- Uncomment below if you prefer to use an image logo -->
        <!-- <a href="index.html" class="logo mr-auto"><img src="assets/img/logo.png" alt="" class="img-fluid"></a>-->

        <nav class="nav-menu d-none d-lg-block">
<!--          <ul>-->
<!--            <li class="active"><router-link :to="{name: 'generalUserHome'}"> Ekhoni Daktar</router-link></li>-->
<!--            <li><a href="#services">Services</a></li>-->
<!--            <li><a href="#departments">Departments</a></li>-->
<!--&lt;!&ndash;            <li><a href="#doctors">Doctors</a></li>&ndash;&gt;-->

<!--            <li class="drop-down"><router-link to="#">User Profile</router-link>-->

<!--              <ul>-->
<!--                <li><router-link to="/generalUser/profile">Profile</router-link></li>-->
<!--                <li class="drop-down"><a href="#">Menu</a>-->
<!--                  <ul>-->
<!--                    <li><a href="#">Deep Drop Down 1</a></li>-->
<!--                    <li><a href="#">Deep Drop Down 2</a></li>-->
<!--                    <li><a href="#">Deep Drop Down 3</a></li>-->
<!--                    <li><a href="#">Deep Drop Down 4</a></li>-->
<!--                    <li><a href="#">Deep Drop Down 5</a></li>-->
<!--                  </ul>-->
<!--                </li>-->
<!--                <li><a href="#">Sign Out</a></li>-->
<!--              </ul>-->
<!--            </li>-->

<!--&lt;!&ndash;            <li v-if="getUser"><a href="#contact">{{ getUser.code }}</a></li>&ndash;&gt;-->

<!--            <li><a href="#contact">Contact</a></li>-->
<!--            <li>-->
<!--              <router-link to="activeCall" exact> Live-->
<!--&lt;!&ndash;                <p style="color: red; font-weight: bold">Live</p>&ndash;&gt;-->
<!--&lt;!&ndash;                <p style="background: red;border-radius: 50%;width: 5px;height: 5px; display: inline-block"></p>&ndash;&gt;-->
<!--              </router-link>-->
<!--            </li>-->
<!--            <li>-->
<!--              <router-link to="/login">Login</router-link>-->
<!--            </li>-->
<!--          </ul>-->
        </nav><!-- .nav-menu -->

        <router-link :to="{name: 'doctorLogin'}" class="appointment-btn scrollto">Doctor Login</router-link>

      </div>
    </header><!-- End Header -->

    <div class="">
      <router-view/>
    </div>
    <!-- ======= Footer ======= -->
    <footer id="footer">

      <div class="footer-top">
        <div class="container">
          <div class="row">

            <div class="col-lg-3 col-md-6 footer-contact">
              <router-link :to="{name: 'adminLogin'}" class="appointment-btn scrollto">Admin Login</router-link>

              <h3>Medilab</h3>
              <p>
                A108 Adam Street <br>
                New York, NY 535022<br>
                United States <br><br>
                <strong>Phone:</strong> +1 5589 55488 55<br>
                <strong>Email:</strong> info@example.com<br>
              </p>
            </div>

            <div class="col-lg-2 col-md-6 footer-links">
              <h4>Useful Links</h4>
              <ul>
                <li><i class="bx bx-chevron-right"></i> <a href="#">Home</a></li>
                <li><i class="bx bx-chevron-right"></i> <a href="#">About us</a></li>
                <li><i class="bx bx-chevron-right"></i> <a href="#">Services</a></li>
                <li><i class="bx bx-chevron-right"></i> <a href="#">Terms of service</a></li>
                <li><i class="bx bx-chevron-right"></i> <a href="#">Privacy policy</a></li>
              </ul>
            </div>

            <div class="col-lg-3 col-md-6 footer-links">
              <h4>Our Services</h4>
              <ul>
                <li><i class="bx bx-chevron-right"></i> <a href="#">Web Design</a></li>
                <li><i class="bx bx-chevron-right"></i> <a href="#">Web Development</a></li>
                <li><i class="bx bx-chevron-right"></i> <a href="#">Product Management</a></li>
                <li><i class="bx bx-chevron-right"></i> <a href="#">Marketing</a></li>
                <li><i class="bx bx-chevron-right"></i> <a href="#">Graphic Design</a></li>
              </ul>
            </div>

            <div class="col-lg-4 col-md-6 footer-newsletter">
              <h4>Join Our Newsletter</h4>
              <p>Tamen quem nulla quae legam multos aute sint culpa legam noster magna</p>
              <form action="" method="post">
                <input type="email" name="email"><input type="submit" value="Subscribe">
              </form>
            </div>

          </div>
        </div>
      </div>

      <div class="container d-md-flex py-4">

        <div class="mr-md-auto text-center text-md-left">
          <div class="copyright">
            &copy; Copyright <strong><span>Ekhoni Doctor</span></strong>. All Rights Reserved
          </div>
          <div class="credits">
            <!-- All the links in the footer should remain intact. -->
            <!-- You can delete the links only if you purchased the pro version. -->
            <!-- Licensing information: https://bootstrapmade.com/license/ -->
            <!-- Purchase the pro version with working PHP/AJAX contact form: https://bootstrapmade.com/medilab-free-medical-bootstrap-theme/ -->
            Designed by <a href="https://bootstrapmade.com/">Innova Tech</a>
          </div>
        </div>
        <div class="social-links text-center text-md-right pt-3 pt-md-0">
          <a href="#" class="twitter"><i class="bx bxl-twitter"></i></a>
          <a href="#" class="facebook"><i class="bx bxl-facebook"></i></a>
          <a href="#" class="instagram"><i class="bx bxl-instagram"></i></a>
          <a href="#" class="google-plus"><i class="bx bxl-skype"></i></a>
          <a href="#" class="linkedin"><i class="bx bxl-linkedin"></i></a>
        </div>
      </div>
    </footer><!-- End Footer -->

    <div id="preloader"></div>
    <a href="#" class="back-to-top"><i class="icofont-simple-up"></i></a>


    <!--  Calling modal-->
    <b-modal v-model="showCallDialog"
             centered title="Incoming Call"
             no-close-on-backdrop no-close-on-esc
    >
      <template v-slot:default="">
        <p>Incoming Call from Patient</p>
      </template>
      <template v-slot:modal-footer="{}">
        <!-- Emulate built in modal footer ok and cancel button actions -->

        <b-button size="sm" variant="success" @click="moveToCallPage">
          Accept
        </b-button>

        <b-button size="sm" variant="danger" @click="setCallInfo(null)">
          Cancel
        </b-button>
        <!-- Button with custom close trigger value -->
      </template>
    </b-modal>
    <!--  Calling modal-->
  </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex';
import DoctorService from "@/services/general_user/doctor.service";

const ringtone = new Audio('@/assets/sounds/ringtone.wav');

export default {

  name: 'GeneralUserLayout',
  data() {
    return {
      showCallDialog: false,
    }
  },
  methods: {
    ...mapActions('generalUserCheckup', ['initializeFirebaseListener', 'setCallInfo']),
    ...mapActions('generalUserDoctor',['setdoctortype']),
    moveToCallPage() {

      let routeData = this.$router.resolve({
        name: 'patientCheckup',
        params: {patientcheckup_code: this.getCallInfo.checkup_code}
      });
      window.open(routeData.href, '_blank', 'location=yes,channelmode=yes,fullscreen=yes,scrollbars=yes,status=yes');
    }
  },
  computed: {
    ...mapGetters('generalUserAuth', ['getUser']),
    ...mapGetters('generalUserCheckup', ['isCallIncoming', 'getCallInfo']),
  },
  watch: {
    isCallIncoming: function (newVal) {
      this.showCallDialog = newVal;
      if (newVal) {
        ringtone.play();
      } else {
        this.showCallDialog = false;
        ringtone.pause();
        ringtone.currentTime = 0;
      }
    }
  },
  mounted() {
    // var btn = document.getElementById("ringtone_btn");
    // btn.addEventListener("click", function () {
    //   document.getElementById('my_ringtone').play();
    //   document.getElementById('my_ringtone').muted = false;
    //   console.log('asasd');
    // });
    // btn.click();

    DoctorService.fetchDoctorTypes()
        .then((response) => {
          if (response.status === 200 ) {
            this.setdoctortype(response.data);
          }
        })

    if (this.getUser) {
      this.initializeFirebaseListener(this.getUser.code);
    }
  },
  created() {
  },
  beforeDestroy() {
  }
};
</script>

<style src="./GeneralUserLayout.scss" lang="scss"/>
